import {createSlice} from "@reduxjs/toolkit";

const modalSlice = createSlice({
    name: "modal",
    initialState: {},
    reducers: {
        setModal: (state, {payload}) => {
            return {
                ...state,
                ...payload
            };
        },
        closeModal: (state, {payload}) => {
            return {}
        }
    }
})

export const {setModal, closeModal} = modalSlice.actions;
export default modalSlice.reducer;